import { useInfinitePaginated } from '../../../../shared/hooks/useInfinitePaginated'
import { gewerkKeys } from '../keys'
import { gewerkApi } from '../service'
import { GewerkFilters } from '@myapp/contract'

export function useGewerkeInfiniteQuery(filters: GewerkFilters, options?: { enabled?: boolean }) {
  return useInfinitePaginated({
    queryKey: gewerkKeys.list(filters),
    params: filters,
    fetchFn: ({ page, ...rest }) =>
      gewerkApi.search({ ...rest, page }).then((r) => r.data),
    enabled: options?.enabled,
  })
}
